export const productCategories = [
  {
    label: 'Alcoholic Beverages',
    options: [
      {
        label: 'Accessories',
        value: 'Alcoholic Beverages - Accessories'
      },
      {
        label: 'Beer',
        value: 'Alcoholic Beverages - Beer'
      },
      {
        label: 'Ciders',
        value: 'Alcoholic Beverages - Ciders'
      },
      {
        label: 'Cocktail mixes',
        value: 'Alcoholic Beverages - Cocktail mixes'
      },
      {
        label: 'Domestic wine',
        value: 'Alcoholic Beverages - Domestic wine'
      },
      {
        label: 'Imported wine',
        value: 'Alcoholic Beverages - Imported wine'
      },
      {
        label: 'Specialty wine & Champagne',
        value: 'Alcoholic Beverages - Specialty wine & Champagne'
      },
      {
        label: 'Spirits',
        value: 'Alcoholic Beverages - Spirits'
      }
    ]
  },
  {
    label: 'Non-alcoholic Beverages',
    options: [
      {
        label: 'Cocoa',
        value: 'Non-alcoholic Beverages - Cocoa'
      },
      {
        label: 'Coffee',
        value: 'Non-alcoholic Beverages - Coffee'
      },
      {
        label: 'Energy & Sports drinks',
        value: 'Non-alcoholic Beverages - Energy & Sports drinks'
      },
      {
        label: 'Juice, Cordials & Nectars',
        value: 'Non-alcoholic Beverages - Juice, Cordials & Nectars'
      },
      {
        label: 'Soft Drinks',
        value: 'Non-alcoholic Beverages - Soft Drinks'
      },
      {
        label: 'Tea',
        value: 'Non-alcoholic Beverages - Tea'
      },
      {
        label: 'Water & Drinks',
        value: 'Non-alcoholic Beverages - Water & Drinks'
      }
    ]
  },
  {
    label: 'Baking',
    options: [
      {
        label: 'Baking Dough, Pastry & Mixes',
        value: 'Baking - Baking Dough, Pastry & Mixes'
      },
      {
        label: 'Baking Ingredients',
        value: 'Baking - Baking Ingredients'
      },
      {
        label: 'Baking Supplies & Decor',
        value: 'Baking - Baking Supplies & Decor'
      },
      {
        label: 'Sugar, Sweeteners & Substitutes',
        value: 'Baking - Sugar, Sweeteners & Substitutes'
      }
    ]
  },
  {
    label: 'Bread & Bakery Products',
    options: [
      {
        label: 'Bakery Desserts',
        value: 'Bread & Bakery Products - Bakery Desserts'
      },
      {
        label: 'Bread',
        value: 'Bread & Bakery Products - Bread'
      },
      {
        label: 'Breakfast Bakery',
        value: 'Bread & Bakery Products - Breakfast Bakery'
      },
      {
        label: 'Savoury Bakery',
        value: 'Bread & Bakery Products - Savoury Bakery'
      }
    ]
  },
  {
    label: 'Breakfast & Cereal',
    options: [
      {
        label: 'Breakfast Bars & Snacks',
        value: 'Breakfast & Cereal - Breakfast Bars & Snacks'
      },
      {
        label: 'Cereal',
        value: 'Breakfast & Cereal - Cereal'
      },
      {
        label: 'Granola & Muesli',
        value: 'Breakfast & Cereal - Granola & Muesli'
      },
      {
        label: 'Oatmeal & Hot Cereal',
        value: 'Breakfast & Cereal - Oatmeal & Hot Cereal'
      }
    ]
  },
  {
    label: 'Canned Goods & Soup',
    options: [
      {
        label: 'Canned Beans',
        value: 'Canned Goods & Soup - Canned Beans'
      },
      {
        label: 'Canned Fish',
        value: 'Canned Goods & Soup - Canned Fish'
      },
      {
        label: 'Canned Fruit',
        value: 'Canned Goods & Soup - Canned Fruit'
      },
      {
        label: 'Canned Meals',
        value: 'Canned Goods & Soup - Canned Meals'
      },
      {
        label: 'Canned Meat',
        value: 'Canned Goods & Soup - Canned Meat'
      },
      {
        label: 'Canned Vegetables',
        value: 'Canned Goods & Soup - Canned Vegetables'
      },
      {
        label: 'Soup, Broth & Bouillon',
        value: 'Canned Goods & Soup - Soup, Broth & Bouillon'
      }
    ]
  },
  {
    label: 'Condiments & Spices',
    options: [
      {
        label: 'Dessert Sauces & Toppings',
        value: 'Condiments & Spices - Dessert Sauces & Toppings'
      },
      {
        label: 'Honey, Syrup & Nectar',
        value: 'Condiments & Spices - Honey, Syrup & Nectar'
      },
      {
        label: 'Jams, Spreads & Condiments',
        value: 'Condiments & Spices - Jams, Spreads & Condiments'
      },
      {
        label: 'Meal Bases',
        value: 'Condiments & Spices - Meal Bases'
      },
      {
        label: 'Pickles, Relish & Olives',
        value: 'Condiments & Spices - Pickles, Relish & Olives'
      },
      {
        label: 'Salad Dressings & Toppings',
        value: 'Condiments & Spices - Salad Dressings & Toppings'
      },
      {
        label: 'Sauces, Marinades & Mixes',
        value: 'Condiments & Spices - Sauces, Marinades & Mixes'
      },
      {
        label: 'Seasoning, Spices & Herbs',
        value: 'Condiments & Spices - Seasoning, Spices & Herbs'
      },
      {
        label: 'Vinegar & Oil',
        value: 'Condiments & Spices - Vinegar & Oil'
      }
    ]
  },
  {
    label: 'Confectionery & Snacks',
    options: [
      {
        label: 'Biscuits/Cookies',
        value: 'Confectionery & Snacks - Biscuits/Cookies'
      },
      {
        label: 'Candy',
        value: 'Confectionery & Snacks - Candy'
      },
      {
        label: 'Chips',
        value: 'Confectionery & Snacks - Chips'
      },
      {
        label: 'Chocolate',
        value: 'Confectionery & Snacks - Chocolate'
      },
      {
        label: 'Crackers',
        value: 'Confectionery & Snacks - Crackers'
      },
      {
        label: 'Desserts & Pudding',
        value: 'Confectionery & Snacks - Desserts & Pudding'
      },
      {
        label: 'Gum',
        value: 'Confectionery & Snacks - Gum'
      },
      {
        label: 'Jerky',
        value: 'Confectionery & Snacks - Jerky'
      },
      {
        label: 'Mints',
        value: 'Confectionery & Snacks - Mints'
      },
      {
        label: 'Popcorn',
        value: 'Confectionery & Snacks - Popcorn'
      },
      {
        label: 'Pretzels',
        value: 'Confectionery & Snacks - Pretzels'
      },
      {
        label: 'Snack bars',
        value: 'Confectionery & Snacks - Snack bars'
      }
    ]
  },
  {
    label: 'Dairy, Cream & Eggs',
    options: [
      {
        label: 'Butter & Sour Cream',
        value: 'Dairy, Cream & Eggs - Butter & Sour Cream'
      },
      {
        label: 'Cheese',
        value: 'Dairy, Cream & Eggs - Cheese'
      },
      {
        label: 'Eggs',
        value: 'Dairy, Cream & Eggs - Eggs'
      },
      {
        label: 'Milk alternatives',
        value: 'Dairy, Cream & Eggs - Milk alternatives'
      },
      {
        label: 'Milk & Cream',
        value: 'Dairy, Cream & Eggs - Milk & Cream'
      },
      {
        label: 'Yogurt / Yoghurt',
        value: 'Dairy, Cream & Eggs - Yogurt / Yoghurt'
      }
    ]
  },
  {
    label: 'Deli',
    options: [
      {
        label: 'Deli Cheese',
        value: 'Deli - Deli Cheese'
      },
      {
        label: 'Deli Meat',
        value: 'Deli - Deli Meat'
      },
      {
        label: 'Deli Sides & Meals',
        value: 'Deli - Deli Sides & Meals'
      },
      {
        label: 'Deli Specialty Foods',
        value: 'Deli - Deli Specialty Foods'
      }
    ]
  },
  {
    label: 'Frozen',
    options: [
      {
        label: 'Frozen Appetizers',
        value: 'Frozen - Frozen Appetizers'
      },
      {
        label: 'Frozen Convenience Meals',
        value: 'Frozen - Frozen Convenience Meals'
      },
      {
        label: 'Frozen Dessert',
        value: 'Frozen - Frozen Dessert'
      },
      {
        label: 'Frozen Entertainment Meal Solutions',
        value: 'Frozen - Frozen Entertainment Meal Solutions'
      },
      {
        label: 'Frozen Fruit',
        value: 'Frozen - Frozen Fruit'
      },
      {
        label: 'Frozen Ice Cream',
        value: 'Frozen - Frozen Ice Cream'
      },
      {
        label: 'Frozen Meals and Sides',
        value: 'Frozen - Frozen Meals and Sides'
      },
      {
        label: 'Frozen Meat',
        value: 'Frozen - Frozen Meat'
      },
      {
        label: 'Frozen Meat Alternatives/Substitutes',
        value: 'Frozen - Frozen Meat Alternatives/Substitutes'
      },
      {
        label: 'Frozen Pizza',
        value: 'Frozen - Frozen Pizza'
      },
      {
        label: 'Frozen Poultry',
        value: 'Frozen - Frozen Poultry'
      },
      {
        label: 'Frozen Seafood',
        value: 'Frozen - Frozen Seafood'
      },
      {
        label: 'Frozen Vegetables',
        value: 'Frozen - Frozen Vegetables'
      }
    ]
  },
  {
    label: 'Fruit, Nuts & Vegetables',
    options: [
      {
        label: 'Dried Fruit',
        value: 'Fruit, Nuts & Vegetables - Dried Fruit'
      },
      {
        label: 'Dried Vegetables',
        value: 'Fruit, Nuts & Vegetables - Dried Vegetables'
      },
      {
        label: 'Fresh Fruit',
        value: 'Fruit, Nuts & Vegetables - Fresh Fruit'
      },
      {
        label: 'Fresh Vegetables & Herbs',
        value: 'Fruit, Nuts & Vegetables - Fresh Vegetables & Herbs'
      },
      {
        label: 'Nuts & Seeds',
        value: 'Fruit, Nuts & Vegetables - Nuts & Seeds'
      },
      {
        label: 'Packaged Salad',
        value: 'Fruit, Nuts & Vegetables - Packaged Salad'
      }
    ]
  },
  {
    label: 'Grains & Pasta',
    options: [
      {
        label: 'Pasta',
        value: 'Grains & Pasta - Pasta'
      },
      {
        label: 'Pasta Sauce',
        value: 'Grains & Pasta - Pasta Sauce'
      },
      {
        label: 'Rice, Beans & Grains',
        value: 'Grains & Pasta - Rice, Beans & Grains'
      },
      {
        label: 'Speciality Pasta',
        value: 'Grains & Pasta - Speciality Pasta'
      }
    ]
  },
  {
    label: 'International Food',
    options: [
      {
        label: 'Asian',
        value: 'International Food - Asian'
      },
      {
        label: 'Indian',
        value: 'International Food - Indian'
      },
      {
        label: 'Italian',
        value: 'International Food - Italian'
      },
      {
        label: 'Kosher',
        value: 'International Food - Kosher'
      },
      {
        label: 'Mexican',
        value: 'International Food - Mexican'
      },
      {
        label: 'Middle Eastern',
        value: 'International Food - Middle Eastern'
      },
      {
        label: 'Other International Foods',
        value: 'International Food - Other International Foods'
      }
    ]
  },
  {
    label: 'Meals & Sides',
    options: [
      {
        label: 'Dinner & Side Dishes',
        value: 'Meals & Sides - Dinner & Side Dishes'
      },
      {
        label: 'Packaged Meals',
        value: 'Meals & Sides - Packaged Meals'
      }
    ]
  },
  {
    label: 'Meat & Seafood',
    options: [
      {
        label: 'Beef',
        value: 'Meat & Seafood - Beef'
      },
      {
        label: 'Chicken',
        value: 'Meat & Seafood - Chicken'
      },
      {
        label: 'Fish & Shellfish',
        value: 'Meat & Seafood - Fish & Shellfish'
      },
      {
        label: 'Game',
        value: 'Meat & Seafood - Game'
      },
      {
        label: 'Lamb',
        value: 'Meat & Seafood - Lamb'
      },
      {
        label: 'Meat Alternatives/Substitutes',
        value: 'Meat & Seafood - Meat Alternatives/Substitutes'
      },
      {
        label: 'Pork',
        value: 'Meat & Seafood - Pork'
      },
      {
        label: 'Salami & Lunch Meats',
        value: 'Meat & Seafood - Salami & Lunch Meats'
      },
      {
        label: 'Sausages, Hot Dogs & Bacon',
        value: 'Meat & Seafood - Sausages, Hot Dogs & Bacon'
      },
      {
        label: 'Turkey',
        value: 'Meat & Seafood - Turkey'
      }
    ]
  },
  {
    label: 'Seasonal',
    options: [
      {
        label: 'Baking',
        value: 'Seasonal - Baking'
      },
      {
        label: 'Bread and Bakery',
        value: 'Seasonal - Bread and Bakery'
      },
      {
        label: 'Breakfast and Cereal',
        value: 'Seasonal - Breakfast and Cereal'
      },
      {
        label: 'Canned Goods and Soup',
        value: 'Seasonal - Canned Goods and Soup'
      },
      {
        label: 'Condiments and Spices',
        value: 'Seasonal - Condiments and Spices'
      },
      {
        label: 'Confectionary and Snacks',
        value: 'Seasonal - Confectionary and Snacks'
      },
      {
        label: 'Dairy, Dream and Eggs',
        value: 'Seasonal - Dairy, Dream and Eggs'
      },
      {
        label: 'Deli',
        value: 'Seasonal - Deli'
      },
      {
        label: 'Frozen',
        value: 'Seasonal - Frozen'
      },
      {
        label: 'Fruits, Nuts and Vegetables',
        value: 'Seasonal - Fruits, Nuts and Vegetables'
      },
      {
        label: 'Grains, Pasta and Sides',
        value: 'Seasonal - Grains, Pasta and Sides'
      },
      {
        label: 'Health',
        value: 'Seasonal - Health'
      },
      {
        label: 'International',
        value: 'Seasonal - International'
      },
      {
        label: 'Meat and Seafood',
        value: 'Seasonal - Meat and Seafood'
      }
    ]
  },
  {
    label: 'Foodservice',
    options: [
      {
        label: 'Baking',
        value: 'Foodservice - Baking'
      },
      {
        label: 'Canned Goods & Soup',
        value: 'Foodservice - Canned Goods & Soup'
      },
      {
        label: 'Condiments & Spices',
        value: 'Foodservice - Condiments & Spices'
      },
      {
        label: 'Confectionery & Snacks',
        value: 'Foodservice - Confectionery & Snacks'
      },
      {
        label: 'Dairy, Cream & Egg',
        value: 'Foodservice - Dairy, Cream & Egg'
      },
      {
        label: 'Deli',
        value: 'Foodservice - Deli'
      },
      {
        label: 'Frozen Foods',
        value: 'Foodservice - Frozen Foods'
      },
      {
        label: 'Fruit, Nuts & Vegetables',
        value: 'Foodservice - Fruit, Nuts & Vegetables'
      },
      {
        label: 'Grains & Pasta',
        value: 'Foodservice - Grains & Pasta'
      },
      {
        label: 'International Food',
        value: 'Foodservice - International Food'
      },
      {
        label: 'Meals & Sides',
        value: 'Foodservice - Meals & Sides'
      },
      {
        label: 'Meat & Seafood',
        value: 'Foodservice - Meat & Seafood'
      },
      {
        label: 'Seasonal',
        value: 'Foodservice - Seasonal'
      }
    ]
  },
  {
    label: 'Foodservice Beverages',
    options: [
      {
        label: 'Alcoholic',
        value: 'Foodservice Beverages - Alcoholic'
      },
      {
        label: 'Frozen Dispensed',
        value: 'Foodservice Beverages - Frozen Dispensed'
      },
      {
        label: 'Hot Dispensed',
        value: 'Foodservice Beverages - Hot Dispensed'
      },
      {
        label: 'Non Alcoholic',
        value: 'Foodservice Beverages - Non Alcoholic'
      }
    ]
  },
  {
    label: 'Cigarettes/Tobacco',
    options: [
      {
        label: 'Cigarettes',
        value: 'Cigarettes/Tobacco - Cigarettes'
      },
      {
        label: 'Tobacco',
        value: 'Cigarettes/Tobacco - Tobacco'
      }
    ]
  },
  {
    label: 'Smoking Accessories',
    options: [
      {
        label: 'Accessories',
        value: 'Smoking Accessories - Accessories'
      }
    ]
  }
]
